export function formattingAction(
    _id: string | any,
    clientId?: string,
    packetId?: string,
    documentId?: string,
    stepId?: string
): actionsObj {
    let actions: actionsObj = {
        uuid: '',
    };
    if (typeof _id === 'string') {
        actions.uuid = _id;
    } else if (typeof _id === 'object' && Object.keys(_id).includes('_id')) {
        actions.uuid =
            Object.values<string>(_id).find((i, s) =>
                Object.keys(_id).some((o, c) => c === s && o === '_id')
            ) ?? '';
    }
    switch (arguments.length) {
        case 1:
            // doo
            break;
        case 2:
            actions = {
                ...actions,
                clientId,
            };
            break;
        case 3:
            actions = {
                ...actions,
                clientId,
                packetId,
            };
            break;
        case 4:
            actions = {
                ...actions,
                clientId,
                packetId,
                documentId,
            };
            break;
        case 5:
            actions = {
                ...actions,
                clientId,
                packetId,
                documentId,
                stepId,
            };
            break;
        default:
            break;
    }
    return actions;
}
